import { Controller } from '@hotwired/stimulus';
import { visit } from '@hotwired/turbo';

// Frame d'un travail en tâche de fond (exports, lecture de DOE) : tant
// qu'elle contient un élément « en cours » (sélecteur `busy`), elle est
// rechargée toutes les 5 s depuis l'adresse courante (page et tri gardés), à
// compter de chaque réponse (même sans HTML, dont la Frame ne dit rien) ;
// arrêt en quittant la page. Échec passager (réseau, page d'erreur sans la
// Frame) : nouvel essai au tour suivant ; une redirection (session expirée)
// mène à la page entière. `reload` : à la fin du travail (plus rien en
// cours), la page entière est rechargée et montre le résultat.
export default class extends Controller {
    static values = { busy: String, reload: Boolean };

    connect() {
        this.wasBusy = this.busy();
        this.schedule();
    }

    disconnect() {
        clearTimeout(this.timer);
    }

    schedule() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 5000);
    }

    retry(event) {
        if (event.detail.response.redirected) return;
        event.preventDefault();
        this.schedule();
    }

    rendered() {
        const busy = this.busy();
        if (this.reloadValue && this.wasBusy && !busy) visit(window.location.href, { action: 'replace' });
        this.wasBusy = busy;
    }

    busy() {
        return Boolean(this.busyValue && this.element.querySelector(this.busyValue));
    }

    refresh() {
        if (!this.busy()) return;
        this.element.src = window.location.href;
    }
}
